// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Asset/Wallpaper.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
  height: 100%;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* LoginPage.jsx */
.ContentLogin {
  flex: 2 1;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 30px;
  padding-bottom: 30px;
  margin-top: 100px;
  background-color: rgba(250, 250, 250, 0.7);
  width: 50%;
}
.TitleContainer {
  align-items: center;
}
.Label {
  color: #1f4529;
  font-size: 25px;
  font-weight: bolder;
  text-align: center;
}
.FCtrlContainer {
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  height: 50px;
}
.FCtrlContent {
  flex: 1 1;
  margin-right: 12px;
  justify-content: center;
  align-items: center;
  border-radius: 16;
  height: 100%;
  width: 100%;
}
.ButtonLogin {
  background-color: #1f4529 !important;
  color: #c2ffc7 !important;
  border-color: #1f4529 !important;
  font-size: 20px !important;
  font-weight: bolder !important;
  width: 50%;
}

/* ResultPage.jsx */
.ContentResult {
  flex: 2 1;
  background-color: rgba(250, 250, 250, 0.7);
  margin-top: 30px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.ButtonSearch {
  /* background-color: #c2ffc7 !important; */
  border-color: #c2ffc7 !important;
  /* color: #1f4529 !important; */
}
.ThStyle {
  font-size: 12px;
  font-weight: normal;
}

/* Preloader.jsx */
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
}
#loader {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #9370db;
  animation: spin 2s linear infinite;
}
#loader:before {
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #ba55d3;
  animation: spin 3s linear infinite;
}
#loader:after {
  content: "";
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #ff00ff;
  animation: spin 1.5s linear infinite;
}
#loading-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000; /* Change the color as needed */
  font-size: 24px; /* Adjust the font size as needed */
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* FOR SMALLER DEVICE */
@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .Content {
    flex: 2 1;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 30px;
    padding-bottom: 30px;
    margin-top: 100px;
    background-color: rgba(250, 250, 250, 0.7);
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,yDAA8C;EAI9C,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EAEzB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EAEzB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EAEzB,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW,EAAE,+BAA+B;EAC5C,eAAe,EAAE,mCAAmC;AACtD;AAaA;EACE;IAGE,uBAAuB;EACzB;EACA;IAGE,yBAAyB;EAC3B;AACF;;AAEA,uBAAuB;AACvB;;EAEE;IACE,SAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,0CAA0C;IAC1C,WAAW;EACb;AACF","sourcesContent":["body {\n  background-image: url(\"./Asset/Wallpaper.jpg\");\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  height: 100%;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* LoginPage.jsx */\n.ContentLogin {\n  flex: 2;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n  margin-top: 100px;\n  background-color: rgba(250, 250, 250, 0.7);\n  width: 50%;\n}\n.TitleContainer {\n  align-items: center;\n}\n.Label {\n  color: #1f4529;\n  font-size: 25px;\n  font-weight: bolder;\n  text-align: center;\n}\n.FCtrlContainer {\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 20px;\n  height: 50px;\n}\n.FCtrlContent {\n  flex: 1;\n  margin-right: 12px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 16;\n  height: 100%;\n  width: 100%;\n}\n.ButtonLogin {\n  background-color: #1f4529 !important;\n  color: #c2ffc7 !important;\n  border-color: #1f4529 !important;\n  font-size: 20px !important;\n  font-weight: bolder !important;\n  width: 50%;\n}\n\n/* ResultPage.jsx */\n.ContentResult {\n  flex: 2;\n  background-color: rgba(250, 250, 250, 0.7);\n  margin-top: 30px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n.ButtonSearch {\n  /* background-color: #c2ffc7 !important; */\n  border-color: #c2ffc7 !important;\n  /* color: #1f4529 !important; */\n}\n.ThStyle {\n  font-size: 12px;\n  font-weight: normal;\n}\n\n/* Preloader.jsx */\n#preloader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n#loader {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 50%;\n  width: 150px;\n  height: 150px;\n  margin: -75px 0 0 -75px;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: #9370db;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n#loader:before {\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  right: 5px;\n  bottom: 5px;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: #ba55d3;\n  -webkit-animation: spin 3s linear infinite;\n  animation: spin 3s linear infinite;\n}\n#loader:after {\n  content: \"\";\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  right: 15px;\n  bottom: 15px;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: #ff00ff;\n  -webkit-animation: spin 1.5s linear infinite;\n  animation: spin 1.5s linear infinite;\n}\n#loading-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #000; /* Change the color as needed */\n  font-size: 24px; /* Adjust the font size as needed */\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/* FOR SMALLER DEVICE */\n@media only screen and (max-width: 760px),\n  (min-device-width: 768px) and (max-device-width: 1024px) {\n  .Content {\n    flex: 2;\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-top: 30px;\n    padding-bottom: 30px;\n    margin-top: 100px;\n    background-color: rgba(250, 250, 250, 0.7);\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
